/**
 * Shared InstantDB configuration helpers.
 *
 * The Instant app id is intentionally derived once so both client and server
 * codepaths stay in sync about whether we should run in mock mode.
 */

const PUBLIC_APP_ID = process.env.NEXT_PUBLIC_INSTANTDB_APP_ID?.trim() || ""
const SERVER_APP_ID = process.env.INSTANTDB_APP_ID?.trim() || ""

const RESOLVED_APP_ID = (PUBLIC_APP_ID || SERVER_APP_ID || "").trim()
const IS_PLACEHOLDER = RESOLVED_APP_ID === "placeholder_app_id"

export const INSTANT_APP_ID = RESOLVED_APP_ID
export const IS_INSTANT_MOCK_MODE = !RESOLVED_APP_ID || IS_PLACEHOLDER

export function getInstantAppId() {
  return IS_INSTANT_MOCK_MODE ? null : INSTANT_APP_ID
}


